import React from 'react';
import styled from 'styled-components';

import { colorTokens } from '../../../../../tokens/globals/tokens';
import { SiteKitIcon } from '../SiteKitIcon';

import { buttonTokens } from '../../../../../tokens/components/Button/tokens';

// Fragments
const IconButtonWrapper = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: transparent;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  &:focus {
    box-shadow: ${buttonTokens.ShadowSecondaryKeyboardFocus};
  }

  &:focus:not(:focus-visible) {
    box-shadow: none;
  }

  &:focus-visible {
    box-shadow: none;
    outline: ${buttonTokens.OutlineStrokeSecondaryKeyboardFocus} ${buttonTokens.OutlineColorSecondaryKeyboardFocus};
    outline-offset: ${buttonTokens.OutlineOffsetSecondaryDefault};
  }
`;

const SiteKitIconWrapper = styled.i`
  display: inline-flex;
  place-items: center;
  color: ${colorTokens.GlobalBrandBlack};
`;

// Exports
interface SiteKitIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string;
  label: string;
  theme?: 'light' | 'light-secondary';
}
const SiteKitIconButton = (props: SiteKitIconButtonProps) => {
  const { label, theme, icon, ...otherProps } = props;

  return (
    <IconButtonWrapper {...otherProps} aria-label={label}>
      <SiteKitIconWrapper>
        <SiteKitIcon theme={theme} icon={icon} />
      </SiteKitIconWrapper>
    </IconButtonWrapper>
  );
};

SiteKitIconButton.displayName = 'SiteKit.IconButton';

export { SiteKitIconButton, SiteKitIconButtonProps };
